import React from 'react'
import { Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { dateToDashString } from '../../../../utils/dateUtility'
import getLocaleCurrencyForAmount from '../../../../utils/getLocaleCurrencyForAmount'
import { formatBigFixedTwoDecimals } from '../../../../utils/bigJSHelper'
import { BoldText, LabelText } from './StyledComponentsContent'
import { PaymentCompleteContentProps } from '../types'
import { getAmountFromLocaleCurrency } from '../../../../utils/getAmountFromLocalCurrency'
import { currencyCode } from '../../../../mockData/MockCommunityFinancials'

export const PaymentCompleteContent: React.FC<PaymentCompleteContentProps> = ({
  isCardSelected,
  isBankSelected,
  isLicensing,
  total,
  amountOfPayment,
  isLcd,
}) => {
  const { t } = useTranslation()

  return (
    <>
      <Typography variant="body1" align="center">
        {t(
          'PaymentModal.Instructions.CheckInbox',
          'Check your inbox for a receipt of this transaction.'
        )}
        &nbsp;
        {isBankSelected &&
          t(
            'PaymentModal.Instructions.BusinessDays',
            'Please allow between 5-7 business days for processing. Our accounting staff will be in contact if there are any issues.'
          )}
      </Typography>
      <LabelText variant="subtitle2" align="center">
        {t('PaymentModal.Label.DateSubmitted', 'Date Submitted')}
        <BoldText variant="body2">{dateToDashString(new Date())}</BoldText>
      </LabelText>
      <LabelText variant="subtitle2" align="center">
        {t('PaymentModal.Label.Amount', 'Amount')}
        <BoldText variant="body2">
          {isLcd
            ? getLocaleCurrencyForAmount(
                formatBigFixedTwoDecimals(total),
                currencyCode
              )
            : getLocaleCurrencyForAmount(
                isBankSelected && !isLicensing
                  ? formatBigFixedTwoDecimals(total)
                  : !!amountOfPayment
                  ? getAmountFromLocaleCurrency(amountOfPayment)
                  : formatBigFixedTwoDecimals(total),
                currencyCode
              )}
        </BoldText>
      </LabelText>
      <LabelText variant="subtitle2" align="center">
        {t('PaymentModal.Label.PaymentMethod', 'Payment Method')}
        <BoldText variant="body2">
          {isCardSelected
            ? t('PaymentModal.MethodOfPayment.CreditCard', 'Credit Card')
            : t(
                'PaymentModal.MethodOfPayment.BankAccountTransfer',
                'Bank Account Transfer'
              )}
        </BoldText>
      </LabelText>
    </>
  )
}
